<template>
  <div class="common-padding-left common-padding-right">
    <div class="row">
      <div class="col col-12 col-md-3 col-lg-3"><SideBar :dataList="dataList" /></div>
      <div class="col col-12 col-md-9 col-lg-9 common-padding-top">
        <h1>退款</h1>
        <p></p>
        <h4>接口说明</h4>
        <div class="font-12 common-padding-bottom-2">
          <div><span class="font-weight-bold">测试URL：</span><span>http://test.api.route.hangmuxitong.com</span></div>
          <div><span class="font-weight-bold">生产URL：</span><span>https://api.yunfastpay.com</span></div>
          <div><span class="font-weight-bold">请求方式：</span><span>POST</span></div>
          <div>dome请见RefundTrans，<router-link tag="a" :to="{path:'/interface/zysm'}">下载deom</router-link>
          </div>
        </div>
        <h4>请求参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>交易码</td><td>trscode</td><td>String（32）</td><td>是</td><td>TRANS0107</td></tr>
          <tr><td>商户编号</td><td>mchtCd</td><td>String(15)</td><td>是</td><td>商户入驻成功后，生成的全局唯一的商户编号</td></tr>
          <tr><td>退款外部订单号</td><td>outOrderId</td><td>String（32）</td><td>否</td><td>退款交易的商家订单号</td></tr>
          <tr><td>原外部订单号</td><td>oglOrdId</td><td>String（32）</td><td>否</td><td>原支付订单外部订单号（与oglOrderCd二选一）</td></tr>
          <tr><td>原订单号</td><td>oglOrderCd</td><td>String（32）</td><td>否</td><td>原支付订单平台订单号（与ooglOrdId二选一）</td></tr>
          <tr><td>原交易日期</td><td>oglOrdDate</td><td>String（8）</td><td>是</td><td>原支付订单日期，格式：yyyyMMdd</td></tr>
          <tr><td>退款金额</td><td>transAmt</td><td>String（16）</td><td>是</td><td></td></tr>
          <tr><td>异步通知地址</td><td>notifyUrl</td><td>String(255)</td><td>否</td><td></td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
        <h4>应答参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>应答码</td><td>respCode</td><td>String（12）</td><td>是</td><td>成功：0000  失败：非0000，具体失败查看描述</td></tr>
          <tr><td>应答描述</td><td>respMsg</td><td>String（512）</td><td>是</td><td>对应应答码信息描述，包含中文</td></tr>
          <tr><td>平台流水号</td><td>orderCd</td><td>String(20)</td><td>否</td><td>平台返回的交易流水号</td></tr>
          <tr><td>渠道原交易订单号</td><td>channelNo</td><td>String(50)</td><td>否</td><td>支付渠道原交易订单号</td></tr>
          <tr><td>外部订单号</td><td>outOrderId</td><td>String（32）</td><td>否</td><td>合作方自定义订单号，唯一标识一笔交易</td></tr>
          <tr><td>交易状态</td><td>transStatus</td><td>String(10)</td><td>否</td><td>100-支付成功（支付订单）或退款成功（退款订单）
            101-待支付
            102-支付失败（支付订单）或退款失败（退款订单）
            103-订单处理中
            104-已撤销</td></tr>
          <tr><td>渠道应答码</td><td>chnlRespCode</td><td>String（12）</td><td>否</td><td></td></tr>
          <tr><td>渠道应答描述</td><td>chnlRespMsg</td><td>String（512）</td><td>否</td><td></td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/pages/interface/components/SideBar'
export default {
  name: 'Tk',
  components: {
    SideBar
  },
  data () {
    return {
      dataList: [
        {'url': '/interface/tk', 'name': '退款'},
        {'url': '/interface/cx', 'name': '交易查询'},
        {'url': '/interface/ybtz', 'name': '异步通知'}]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/components/Tk.vue